module.exports = __webpack_public_path__ + "static/img/img_p3_2_pic.d122019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p3_2_pic.png
// module id = X7XK
// module chunks = 1